import { Button, Modal, message } from "antd";
import {
	NotificationProvider,
	NotificationTempProvider,
} from "views/mobile/components/Notification";
import React, { useDispatch, useEffect, useGlobal } from "reactn";

const Notification = ({ component, visible }) => {
	return (
		<Modal visible={visible} footer={null} closable={false}>
			{component}
		</Modal>
	);
};
const NotificationTemp = ({ component, visible }) => {
	return <>{component}</>;
};

export const Message = ({}) => {
	const [messages] = useGlobal("messages");
	const removeMessages = useDispatch("removeMessages");
	useEffect(() => {
		if (messages.length < 1) return;
		messages.forEach((m) => message.success(m));
		removeMessages();
	}, [messages]);

	return null;
};

export const NotificationTempPopup = NotificationTempProvider(NotificationTemp);
export default NotificationProvider(Notification);
